export const selectOrganizationState = state => state.organizationState;

export const getBaseOrg = state => state.organizationState.baseOrg;
